import React, { createContext, useState, useEffect, ReactNode } from "react";
import {  fetchTNS } from "../service/service";
import { BlogType, PrivacyContent } from "../types/types";
import { blogData } from "../Resources/BlogData";

export type UserOrNull = {
  id: string;
  email: string;
} | null;

type ThemeType = "dark" | "light";

export interface AuthContextType {
  isAuthenticated: boolean;
  blogs: BlogType[];
  setBlogs: React.Dispatch<React.SetStateAction<BlogType[]>>;
  currentPage: number;
  totalPages: number;
  handlePageChange: (page: number) => void;
  user: UserOrNull;
  setUser: React.Dispatch<React.SetStateAction<UserOrNull>>;
  loading: boolean;
  setIsAuthenticated: React.Dispatch<React.SetStateAction<boolean>>;
  privacyContent: PrivacyContent;
  theme: ThemeType;
  setTheme: (theme: ThemeType) => void;
}

const AuthContext = createContext<AuthContextType | undefined>(undefined);

const AuthProvider: React.FC<{ children: ReactNode }> = ({ children }) => {
  const [isAuthenticated, setIsAuthenticated] = useState<boolean>(false);
  const [user, setUser] = useState<UserOrNull>(null);
  const [loading, setLoading] = useState(false);
  const [blogs, setBlogs] = useState<BlogType[]>([]);
  const [currentPage, setCurrentPage] = useState<number>(1);
  const [totalPages, setTotalPages] = useState<number>(1);
  const [privacyContent, setPrivacyContent] = useState<PrivacyContent>(
    {} as PrivacyContent
  );

  const defaultTheme = localStorage.getItem("theme")

  const [theme, setTheme] = useState<ThemeType>(defaultTheme as ThemeType || "light");

  useEffect(() => {
    const getBlogs = async () => {
      try {
        // const data = await fetchBlogs(currentPage, limit);
        // if (data.status === false) {
        //   toast.error(data.response?.data.message);
        // } else {
        //   setBlogs(data.response?.data.blogs as BlogType[]);
        //   setTotalPages(data.response?.data.totalPages as number);
        // }
        setBlogs(blogData);
        setTotalPages(2);
      } catch (error) {
        console.error("Error fetching blogs:", error);
      }
    };

    getBlogs();
  }, [currentPage]);

  useEffect(() => {
    localStorage.setItem("theme", theme);

    setTheme(localStorage.getItem("theme") as ThemeType);
  }, [theme]);

  useEffect(() => { 
    const getTerms = async () => {
      const response = await fetchTNS();
      if (response.status === 200) {
        setPrivacyContent(response.privacyContent as PrivacyContent);
      }
    };
    getTerms();
  }, []);

  const handlePageChange = (page: number) => {
    if (page >= 1 && page <= totalPages) {
      setCurrentPage(page);
    }

    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  return (
    <AuthContext.Provider
      value={{
        handlePageChange,
        blogs,
        currentPage,
        totalPages,
        setBlogs,
        isAuthenticated,
        privacyContent,
        loading,
        user,
        setUser,
        setIsAuthenticated,
        theme,
        setTheme,
      }}
    >
      <div className="">{children}</div>
    </AuthContext.Provider>
  );
};

export { AuthProvider, AuthContext };
